
import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';

const ColorFinishing = ({ value, onChange, id='ColorFinishing', label = 'Color Finishing', disabled = false, showPics = false }) => {
    const [selectedColorFinishing, setSelectedColorFinishing] = useState(value || "");
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setSelectedColorFinishing(value || "");
    }, [value]);

    const handleColorFinishingChange = (e) => {
        setSelectedColorFinishing(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label
                disabled={disabled}
                htmlFor={id}
                onClick={() => showPics && setShowModal(true)}
                style={{ cursor: showPics ? 'pointer' : 'default' }}
            >
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedColorFinishing}
                onChange={handleColorFinishingChange}
            >
                {/*<option value="" disabled hidden>Select an option</option>*/}
                <option value='None'>{selectedColorFinishing === 'None' ? 'None ✔' : 'None'}</option>
                <option value='Smooth'>{selectedColorFinishing === 'Smooth' ? 'Smooth ✔' : 'Smooth'}</option>
                <option value='Textured'>{selectedColorFinishing === 'Textured' ? 'Textured ✔' : 'Textured'}</option>
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/ColorFinishing"
                imageName={selectedColorFinishing}
                width={200}  //optional               
                height={250} //optional
            />
        </div>
    );
};

export default ColorFinishing;
